
import FulfillmentOptionComponent from './FulfillmentOption.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from '../../../types/LocalStore';
import { useBreakpoints } from 'JS/composables/breakpoint';

@Component({
	name: 'LocalDelivery',
	components: {
		FulfillmentOptionComponent
	}
})
export default class LocalDelivery extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('product')
	readonly product: any;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isDeliveryDisabled')
	readonly isDeliveryDisabled: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;
	
	@Get('isInStockForBopus')
	readonly isInStockForBopus: boolean;

	get isMobile(): boolean {
		return useBreakpoints().isMobile.value;
	} 

	get isSelected(): boolean {
		return this.fulfillmentOption === this.selectedFulfillmentType;
	}	

	get isDisabled(): boolean {
		return this.isDeliveryDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get secondaryLabel(): string {
		if (this.product.notCarriedInStore) {
			return "Not available";
		} else if (this.isInStockForBopus) {
			if (!!this.product.arrivalDate) {
				return "Est. Delivery " + this.product.arrivalDate;
			} else if (this.isMobile) {
				return this.localStore.localDeliveryInformation.labelNewShort;
			} else {
				return this.localStore.localDeliveryInformation.labelNew;
			}
		} else {
			return "Out of Stock";
		}
	}

	get showOrderByDisclaimer(): boolean {
		if (this.product.notCarriedInStore) {
			return false;
		} else if (this.isInStockForBopus) {
			return !!this.product.orderByDate;
		} else {
			return false;
		}
	}

	get deliveryPromo(): string | null {
		if (this.isInStockForBopus) {
			if (this.isMobile) {
				return this.product.deliveryDiscountMessageMobile;
			}
			return this.product.deliveryDiscountMessage;
		}

		return null;
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.LocalDelivery;
}
